// extracted by mini-css-extract-plugin
export default {"weWork":"howWeWork_weWork__WpsDr"};